export default __webpack_public_path__ + "static/media/categoryDefaultImg.5c4680cc.jpg";